import { AxiosRequestConfig } from "axios";
import { getPurposeEndpoint, http, PurposeResponse } from "@/services";

export const requestPurposesList = (
  { email }: { email: string },
  config?: AxiosRequestConfig,
) => http.get<PurposeResponse>(getPurposeEndpoint, { email }, config);
